import {Condition, type Journey} from "../engine/Condition.js";
import {merchantVariableModule} from "../../merchant-state/MerchantVariableModule.js";
import {ExprEvaluator} from "../../TemplateEvaluation.js";

export interface ExprOptions {
    value: string;
}

// TODO do we actually use this anywhere?
export class ExprCondition extends Condition<ExprOptions> {
    constructor(journey: Journey, options: ExprOptions, requestReEval: () => void) {
        super(journey, options, requestReEval);

        // TODO it's kinda wrong if we only reeval this, but all the other expressions are unchanged
        this.attachListener(merchantVariableModule, this.requestReEval);
    }

    evaluate() {
        const evaluator = new ExprEvaluator();
        const value = evaluator.eval(this.options.value);
        // Cast to a bool, since null means "not able to evaluate"
        return !!value;
    }
}
